import * as React from 'react'

export const Leadership = () => (
  <svg
    width="70"
    height="70"
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_431_656)">
      <path
        d="M20.0138 33.1449C18.792 32.65 17.9302 31.4512 17.9302 30.0511V23.4751C17.9302 22.0931 18.7698 20.9074 19.9663 20.401C20.3651 20.2321 23.3675 20.3871 23.3675 23.4751V30.0511C23.3676 33.2265 20.4 33.3013 20.0138 33.1449Z"
        fill="#FFADC8"
      />
      <path
        d="M21.2642 20.1387C20.822 20.1387 20.4003 20.2256 20.0142 20.382C21.2359 20.8771 22.098 22.0749 22.098 23.475V30.0511C22.098 31.4512 21.2359 32.649 20.0142 33.144C20.4003 33.3005 20.822 33.3874 21.2642 33.3874C23.1054 33.3874 24.5981 31.8936 24.5981 30.0511L25.8285 26.7631L24.5981 23.4752C24.5981 21.6325 23.1055 20.1387 21.2642 20.1387Z"
        fill="#FF92B6"
      />
      <path
        d="M26.6817 34.6522C25.46 34.1576 24.5981 32.9598 24.5981 31.5608V20.426C24.5981 19.045 25.4377 17.8602 26.6343 17.354C27.0331 17.1853 30.0354 17.3402 30.0354 20.426V31.5608C30.0354 34.6641 27.0678 34.8085 26.6817 34.6522Z"
        fill="#FFADC8"
      />
      <path
        d="M27.9319 17.0918C27.4898 17.0918 27.068 17.1786 26.6819 17.335C27.9036 17.8297 28.7657 19.0266 28.7657 20.4257V31.5605C28.7657 32.9595 27.9036 34.1566 26.6819 34.6513C27.068 34.8075 27.4896 34.8945 27.9319 34.8945C29.7732 34.8945 31.2658 33.4018 31.2658 31.5606L32.4963 25.9931L31.2658 20.4257C31.2658 18.5845 29.7732 17.0918 27.9319 17.0918Z"
        fill="#FF92B6"
      />
      <path
        d="M36.7032 33.708C36.7032 36.8137 33.7356 36.9582 33.3495 36.8018C32.1277 36.3069 31.2659 35.1081 31.2659 33.708V18.3247C31.2659 16.9427 32.1055 15.757 33.302 15.2506C33.7008 15.0817 36.7032 15.2368 36.7032 18.3247V33.708Z"
        fill="#FFADC8"
      />
      <path
        d="M34.5996 14.9883C34.1575 14.9883 33.7357 15.0752 33.3496 15.2316C34.5713 15.7266 35.4335 16.9245 35.4335 18.3246V33.7078C35.4335 35.1079 34.5713 36.3057 33.3496 36.8008C33.7357 36.9572 34.1575 37.0442 34.5996 37.0442C36.4408 37.0442 37.9335 35.5505 37.9335 33.7078L39.164 25.994L37.9335 18.3246C37.9335 16.4819 36.441 14.9883 34.5996 14.9883Z"
        fill="#FF92B6"
      />
      <path
        d="M40.0172 35.8563C38.796 35.366 37.9336 34.1709 37.9336 32.7745V15.8793C37.9336 14.5044 38.7696 13.3246 39.961 12.8207C40.3582 12.6526 43.3709 12.8069 43.3709 15.8793V32.7745C43.371 35.8678 40.3992 36.0097 40.0172 35.8563Z"
        fill="#FFADC8"
      />
      <path
        d="M41.282 12.5605H41.2532C40.8164 12.5605 40.3996 12.6459 40.0176 12.7991C41.2387 13.2894 42.1014 14.4836 42.1014 15.8801V32.7752C42.1014 34.1717 41.2387 35.3659 40.0176 35.8562C40.3996 36.0096 40.8163 36.0948 41.2532 36.0948H41.282C43.1154 36.0948 44.6015 34.6086 44.6015 32.7752V15.8801C44.6015 14.0468 43.1152 12.5605 41.282 12.5605Z"
        fill="#FF92B6"
      />
      <path
        d="M45.0928 22.6289H43.8232H37.9336H35.2061C34.2307 22.6289 33.4401 23.4506 33.4401 24.4644C33.4445 24.7292 33.451 25.0114 33.5459 25.5003C33.9339 27.3822 35.3584 28.8984 37.2325 29.299L37.9335 29.4488L44.6013 30.8741V31.5285C44.6013 33.371 43.1086 34.8648 41.2674 34.8648C39.4262 34.8648 37.9335 33.371 37.9335 31.5285V31.5453V31.699V32.4772C37.9335 34.3197 36.4408 35.8135 34.5996 35.8135C32.7583 35.8135 31.2657 34.3199 31.2657 32.4772V30.3308C31.2657 32.1721 29.773 33.6647 27.9318 33.6647C26.0906 33.6647 24.5979 32.172 24.5979 30.3308V29.449L24.5487 29.3894C24.2788 30.9608 22.9115 32.157 21.2641 32.157C19.4229 32.157 17.9302 30.6633 17.9302 28.8206V39.1395C17.9302 39.1395 17.9302 46.9743 22.3897 52.2945C23.3869 53.4841 23.9521 54.9987 23.9521 56.5764V61.0917L33.3496 63.5526L42.1012 61.0917L43.3708 59.8612V56.5409C43.3708 55.4871 43.7424 54.4663 44.4245 53.6634C46.0158 51.7902 48.9275 47.8532 49.6888 43.366C51.342 33.6245 52.2093 22.6289 45.0928 22.6289Z"
        fill="#FFCADB"
      />
      <path
        d="M46.3233 22.6289H43.8233C50.9397 22.6289 50.0725 33.6245 48.4196 43.3656C47.6582 47.8527 44.7465 50.5398 43.1553 52.4129C42.4732 53.2159 42.1016 54.2366 42.1016 55.2905V61.0913L43.3154 62.3218L44.6016 61.0913V56.5405C44.6016 55.4866 44.9732 54.4659 45.6553 53.663C47.2466 51.7898 50.1583 47.8528 50.9196 43.3656C52.5726 33.6245 53.4398 22.6289 46.3233 22.6289Z"
        fill="#FFADC8"
      />
      <path
        d="M22.7385 61.7863V69.3071C22.7385 69.6906 23.0494 70.0015 23.4329 70.0015H43.3154L44.585 68.771V62.3223L43.3154 61.0918H23.4329C23.0494 61.0918 22.7385 61.4027 22.7385 61.7863Z"
        fill="#DF5783"
      />
      <path
        d="M43.3152 61.0918V70.0015H45.1207C45.5042 70.0015 45.8151 69.6906 45.8151 69.3071V61.7863C45.8151 61.4028 45.5042 61.0919 45.1207 61.0919H43.3152V61.0918Z"
        fill="#C9426E"
      />
      <path
        d="M43.849 30.7109L43.0698 33.703C41.1672 34.3459 35.3485 36.8214 32.4938 43.7501C32.285 44.2568 32.4725 44.8604 32.9593 45.1118C33.1146 45.192 33.2788 45.2295 33.4397 45.2295C33.8502 45.2295 34.2391 44.9853 34.4043 44.582C37.3541 37.372 44.1203 35.5556 44.186 35.5386C44.5547 35.4456 44.8434 35.1591 44.9393 34.7912L45.7055 31.8488C45.8051 31.466 45.5653 31.0773 45.1784 30.9948L43.849 30.7109Z"
        fill="#FF7CA7"
      />
      <path
        d="M35 8.18891C35.5766 8.18891 36.0437 7.7216 36.0437 7.1452V1.04371C36.0437 0.467305 35.5766 0 35 0C34.4235 0 33.9563 0.467305 33.9563 1.04371V7.1452C33.9563 7.7216 34.4235 8.18891 35 8.18891Z"
        fill="#F95986"
      />
      <path
        d="M9.96366 31.1387H3.86231C3.28577 31.1387 2.8186 31.606 2.8186 32.1824C2.8186 32.7588 3.28577 33.2261 3.86231 33.2261H9.9638C10.5403 33.2261 11.0075 32.7588 11.0075 32.1824C11.0074 31.606 10.5402 31.1387 9.96366 31.1387Z"
        fill="#F95986"
      />
      <path
        d="M66.1376 31.1387H60.0361C59.4596 31.1387 58.9924 31.606 58.9924 32.1824C58.9924 32.7588 59.4596 33.2261 60.0361 33.2261H66.1376C66.7142 33.2261 67.1813 32.7588 67.1813 32.1824C67.1813 31.606 66.7142 31.1387 66.1376 31.1387Z"
        fill="#F95986"
      />
      <path
        d="M57.7558 9.42676C57.3481 9.0192 56.6873 9.0192 56.2796 9.42676L51.9652 13.7412C51.0392 14.7479 52.4203 16.1395 53.4413 15.2172L57.7558 10.9028C58.1633 10.4951 58.1633 9.83432 57.7558 9.42676Z"
        fill="#F95986"
      />
      <path
        d="M61.3914 21.8429C61.1811 21.3061 60.5749 21.0417 60.039 21.2518L57.9304 22.0779C56.6752 22.6497 57.3884 24.4671 58.6916 24.0215L60.8002 23.1954C61.337 22.9852 61.6017 22.3796 61.3914 21.8429Z"
        fill="#F95986"
      />
      <path
        d="M43.7521 9.84203C44.1551 10.0371 44.9214 9.80184 45.1047 9.251L45.9549 7.081C46.1652 6.54438 45.9005 5.93872 45.3639 5.72844C44.8267 5.51817 44.2216 5.78286 44.0113 6.31948L43.1611 8.48948C42.9508 9.0261 43.2155 9.63176 43.7521 9.84203Z"
        fill="#F95986"
      />
      <path
        d="M24.8953 9.25083C25.4605 10.5423 27.2769 9.74411 26.8389 8.48944L25.9887 6.31944C25.7783 5.78268 25.1732 5.51827 24.6361 5.7284C24.0995 5.93868 23.8348 6.54434 24.0451 7.08096L24.8953 9.25083Z"
        fill="#F95986"
      />
      <path
        d="M18.0347 15.2153C18.4423 14.8077 18.4423 14.1468 18.0347 13.7392L13.7203 9.42481C13.3126 9.01725 12.6518 9.01725 12.2441 9.42481C11.8366 9.83237 11.8366 10.4933 12.2441 10.9008L16.5586 15.2153C16.9192 15.5649 17.576 15.6584 18.0347 15.2153Z"
        fill="#F95986"
      />
      <path
        d="M12.0696 22.076L9.96099 21.2499C9.42437 21.0397 8.81871 21.3043 8.60857 21.841C8.3983 22.3777 8.66298 22.9832 9.19974 23.1935L11.3084 24.0196C11.4334 24.0685 11.5621 24.0918 11.6887 24.0918C12.1057 24.0918 12.4994 23.8402 12.6608 23.4285C12.8709 22.8918 12.6064 22.2863 12.0696 22.076Z"
        fill="#F95986"
      />
    </g>
    <defs>
      <clipPath id="clip0_431_656">
        <rect width="70" height="70" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
